import { gql, useQuery, type DocumentNode } from "@apollo/client";
import { ErrorMessage } from "@/shared/components";
import LinearProgress from "@mui/material/LinearProgress";
import { CrudDialogHeader } from "./CrudDialogHeader";

// useQuery требует документ даже при skip — заглушка для вкладок без запроса
const EMPTY_QUERY = gql`
  query EmptyQuery {
    __typename
  }
`;

export interface CrudComponentProps<Data = any> {
  id: string;
  component: React.ComponentType<{ id: string } & Data>;
  componentQuery?: DocumentNode;
  componentQueryVariables?: Record<string, any>;
  onClose?: () => void;
  title?: string;
  subTitle?: string;
  getTitle?: (data: Data) => string | null;
}

export function CrudComponent<Data = any>({
  id,
  componentQuery,
  component: Component,
  componentQueryVariables,
  onClose,
  title,
  subTitle,
  getTitle = () => null,
}: CrudComponentProps<Data>) {
  const { data, loading, error } = useQuery(componentQuery ?? EMPTY_QUERY, {
    fetchPolicy: "cache-and-network",
    variables: {
      id,
      ...componentQueryVariables,
    },
    skip: !componentQuery,
  });

  if (componentQuery) {
    if (error) return <ErrorMessage error={error} />;
    if (loading) return <LinearProgress />;
  }

  return (
    <>
      <CrudDialogHeader
        position="absolute"
        onClose={onClose}
        secondary={title}
        primary={subTitle}
        title={componentQuery && data ? getTitle(data) : null}
      />
      <Component {...(componentQuery ? data : {})} id={id} />
    </>
  );
}
